import React, { useEffect, useState } from 'react'
import { Card, Form, Button, Row, Col, DatePicker, Spin, Table } from 'antd'
import BaseListing from 'src/BaseListings'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper'
import './style.css'
import WidgetItemSelector from 'src/widgets/Selectors/WidgetItemSelector'
import { wtRoundValue } from 'src/helpers/commons/utils'

const ItemIssuanceReport = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()

  const [reportData, setReportData] = useState([])
  const [items, setItems] = useState([])

  const [itemId, setItemId] = useState('')
  const [itemName, setItemName] = useState('')
  const [dateRange, setDateRange] = useState([])

  const Base = new BaseListing('sale_order_report')

  useEffect(() => {
    Base.dropdownData('items', {}, [setItems], 1)
  }, [])

  const handleItemChange = (value) => {
    setItemId(value?.value || '')
    setItemName(value?.label || '')
  }

  const handleSearch = () => {
    if (!dateRange || dateRange.length < 2) {
      lzNotifyErrorMessageFromResult('Please select date range')
      return
    }

    setIsLoading(true)

    wtApiCall(
      'reports/item_issuance_report',
      {
        from_date: dateRange[0].format('YYYY-MM-DD'),
        to_date: dateRange[1].format('YYYY-MM-DD'),
        item_id: itemId,
      },
      'get',
      (response) => {
        setReportData(response?.data || [])
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }

  const exportToExcel = () => {
    if (!reportData.length) {
      lzNotifyErrorMessageFromResult('No data to export')
      return
    }

    setIsLoading(true)

    wtApiPostWithContentTypeHandling('item_serial_report/export', {
      data: reportData,
    }).finally(() => setIsLoading(false))
  }

  const columns = [
    {
      title: 'Sr#',
      render: (_, __, index) => index + 1,
      width: '5%',
    },
    {
      title: 'SOD#',
      dataIndex: ['sale_order', 'code'],
    },
    {
      title: 'DO#',
      dataIndex: ['sale_order_delivery', 'code'],
    },
    {
      title: 'Customer Name',
      render: (render) => render?.sale_order?.party?.name || '',
    },
    {
      title: 'Item Name',
      dataIndex: ['item', 'name'],
    },
    {
      title: 'Item Brand',
      dataIndex: ['item_brand', 'name'],
    },
    {
      title: 'Warehouse',
      render: (render) => render?.sod_issuance?.warehouse?.name || '',
    },
    {
      title: 'QTY',
      render: (render) => wtRoundValue(render.issuing_quantity, 2),
    },
    {
      title: 'Issuance Date',
      dataIndex: ['sod_issuance', 'issuance_date'],
    },
    {
      title: 'Barcode',
      render: (render) => (render?.barcode ? render.barcode : ''),
    },
    {
      title: 'Serial',
      render: (render) => render?.item_barcode?.item_serial?.serial || '',
    },
  ]

  return (
    <div className="container-fluid" style={{ padding: 16, background: '#fff' }}>
      <Form layout="vertical" form={form}>
        <Card
          title={
            <div style={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold' }}>
              Item Issuance Report
            </div>
          }
        >
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={12} md={4}>
              <label>Date Range *</label>
              <DatePicker.RangePicker
                value={dateRange}
                onChange={setDateRange}
                style={{ width: '100%', height: 35 }}
              />
            </Col>

            <Col xs={24} sm={12} md={4}>
              <label>Item Name</label>
              <WidgetItemSelector
                items={items}
                onChange={handleItemChange}
                displayValue={itemName}
                reloadDropdownData={() => Base.dropdownData('items', {}, [setItems], 1)}
                placeHolder="Select Item"
                value={itemId}
              />
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Button
                type="primary"
                style={{ marginTop: 30, marginRight: 8 }}
                onClick={handleSearch}
                disabled={isLoading}
              >
                Search
              </Button>

              <Button
                style={{ marginTop: 30, backgroundColor: '#4BB543', color: '#fff' }}
                onClick={exportToExcel}
                disabled={isLoading}
              >
                Export
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>

      <Card style={{ marginTop: 24 }}>
        <Table
          columns={columns}
          dataSource={reportData}
          rowKey="id"
          bordered
          loading={isLoading}
          pagination={false}
        />
      </Card>
    </div>
  )
}

export default ItemIssuanceReport
